// extracted by mini-css-extract-plugin
export default {"service":"Services_service__72ZUk"};